export const FIREBASE_API = {
    apiKey: 'AIzaSyBernKzdSojh_vWXBHt0aRhf5SC9VLChbM',
    authDomain: 'berry-material-react.firebaseapp.com',
    projectId: 'berry-material-react',
    storageBucket: 'berry-material-react.appspot.com',
    messagingSenderId: '901111229354',
    appId: '1:901111229354:web:a5ae5aa95486297d69d9d3',
    measurementId: 'G-MGJHSL8XW3'
};

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';
export const SERVER_URL = 'https://nabuzsystems.se/api';
//export const SERVER_URL = 'http://localhost:8080/api';
// Live/production api. NOTE: this is never connected to — it's only compared
// against SERVER_URL so the Labels panel can tell whether it's pointed at the
// live backend (label editing is disabled unless SERVER_URL matches this).
export const LIVE_SERVER_URL = 'https://www.nabuzsystems.se/api';
export const DASHBOARD_PATH = '/admins';

export const AWS_API = {
    poolId: 'eu-north-1_0k0Xn3V19',
    appClientId: '732e2kt1q5marvtu9ebu8q43ae'
};

const config = {
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'theme4', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false
};

export default config;
